
import { ReactNode } from 'react';

interface ButtonProps {
  children: ReactNode;
  variant?: 'primary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  onClick?: () => void;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
}

export default function Button({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  onClick, 
  className = '',
  type = 'button'
}: ButtonProps) {
  const baseClasses = 'font-medium transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center justify-center';
  
  const variants = {
    primary: 'bg-amber-800 text-white hover:bg-amber-900 shadow-md hover:shadow-lg',
    outline: 'border-2 border-amber-800 text-amber-800 hover:bg-amber-800 hover:text-white',
    ghost: 'text-amber-800 hover:bg-amber-50'
  };
  
  const sizes = {
    sm: 'px-4 py-2 text-sm rounded-md',
    md: 'px-6 py-3 text-base rounded-lg',
    lg: 'px-8 py-4 text-lg rounded-lg'
  };
  
  return (
    <button
      type={type}
      onClick={onClick}
      className={`${baseClasses} ${variants[variant]} ${sizes[size]} ${className}`}
    >
      {children}
    </button>
  );
}
